"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AspectRatioView = void 0;
var react_native_1 = require("react-native");
var React = require("react");
/**
 * aspect ratio view involves an inner and an outer View
 * uses the padding hack (vertical padding is based on width) rather than computation
 */
exports.AspectRatioView = function (_a) {
    var aspectRatio = _a.aspectRatio, style = _a.style, rest = __rest(_a, ["aspectRatio", "style"]);
    return (React.createElement(react_native_1.View, { style: [
            {
                paddingBottom: 100 / aspectRatio + "%",
                position: 'relative',
                height: 0,
                width: '100%',
            },
            style,
        ] },
        React.createElement(react_native_1.View, __assign({ style: {
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
            } }, rest))));
};
//# sourceMappingURL=AspectRatio.js.map